import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import PenghasilanService from "../../services/PenghasilanService";
import {message} from "antd";

export const initialState = {
    loading: false,
    dataPenghasilan: [],
    dataPenghasilanByID:[],
    showMessage:false,
    message:''
}


export const getDataPenghasilan = createAsyncThunk('ref/penghasilan',async (data, { rejectWithValue }) => {
    try {
        const response = await PenghasilanService.getDataAll(data)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataPenghasilanByID = createAsyncThunk('ref/penghasilanbyid',async (data, { rejectWithValue }) => {
    const {token,id,id_jadwal}=data;
    try {
        const response = await PenghasilanService.getDataByID(token,id,id_jadwal)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const penghasilanSlice = createSlice({
    name: 'penghasilan',
    initialState,
    reducers: {
        showDataSuccess: (state, action) => {
            state.loading = false
            state.dataPenghasilan = action.payload
        },
        showLoading: (state) => {
            state.loading = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPenghasilan.fulfilled, (state, action) => {
                state.loading = false
                state.dataPenghasilan = action.payload
            })
            .addCase(getDataPenghasilan.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataPenghasilan.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataPenghasilan = action.payload
            })
            .addCase(getDataPenghasilanByID.fulfilled, (state, action) => {
                state.loading = false
                state.dataPenghasilanByID = action.payload
            })
            .addCase(getDataPenghasilanByID.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataPenghasilanByID.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataPenghasilanByID = action.payload
            })
    },
})

export const {
    showDataSuccess,
    showLoading
} = penghasilanSlice.actions

export default penghasilanSlice.reducer
